export { default } from './InactiveHoldItem';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/InactiveHoldItem/index.js